import { Navigate, useParams, Link } from "react-router-dom";
import { PageHero, useTitle } from "../components/PageHero";
import { Reveal, Tag } from "../components/Reveal";
import { CTABand } from "../components/CTABand";
import { INSIGHTS } from "../data/insights";

export default function InsightDetail() {
  const { slug } = useParams();
  const a = INSIGHTS.find((x) => x.slug === slug);
  useTitle(a ? `${a.title} | SABAKT Insights` : "SABAKT");
  if (!a) return <Navigate to="/insights" replace />;

  const related = INSIGHTS.filter((x) => x.slug !== slug).slice(0, 3);

  return (
    <main>
      <PageHero eyebrow={`${a.category} · ${a.minutes} min read`} testid="insight-detail-hero" title={a.title} />
      <section className="border-b border-seam py-16 lg:py-24">
        <div className="mx-auto max-w-3xl px-4 sm:px-8">
          {a.body.map((p, i) => (
            <Reveal key={i} delay={i * 0.04}>
              <p className={`mb-6 leading-relaxed ${i === 0 ? "text-lg text-frost/95" : "text-base text-cadmium"}`}>{p}</p>
            </Reveal>
          ))}
          <Reveal className="mt-10 border border-spark/50 bg-iron p-8" data-testid="article-cta">
            <Tag>Have a Similar Requirement?</Tag>
            <p className="mt-3 text-base text-cadmium">
              Send us your drawings, photos or equipment details. Our team will assess your requirement and recommend the appropriate solution.
            </p>
            <Link to="/rfq" data-testid="article-rfq-btn"
              className="mt-5 inline-block bg-gold px-7 py-4 font-display text-base font-bold uppercase tracking-wider text-white transition-colors hover:bg-spark">
              Request a Technical Quote
            </Link>
          </Reveal>
        </div>
      </section>
      <section className="bg-iron py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
          <Tag>Keep Reading</Tag>
          <div className="mt-6 grid gap-px border border-seam bg-seam md:grid-cols-3">
            {related.map((r) => (
              <Link key={r.slug} to={`/insights/${r.slug}`} data-testid={`related-insight-${r.slug}`}
                className="group bg-obsidian p-6 hover:bg-steel">
                <Tag>{r.category}</Tag>
                <h3 className="mt-2 font-display text-lg font-bold uppercase leading-snug text-frost group-hover:text-spark">{r.title}</h3>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <CTABand />
    </main>
  );
}
